import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions,Popper , TextField, MenuItem, Box ,Typography, Card, CardMedia, CardContent } from '@mui/material';
import { Field, Form } from 'react-final-form';
import { Select as RffSelect } from 'mui-rff';
import axios from 'axios';
import { toast } from 'react-toastify';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Tooltip from "@mui/material/Tooltip";
import { Modal, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { platform } from 'os';

const API_KEY = 'AIzaSyByI_l6XffzkdFkoTIOy6tThHkAcDIQNL4';

const isValidYouTubeUrl = (url) => {
  const pattern = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})\b/;
  return pattern.test(url);
};

const validate = (values) => {
  const errors = {};
  if (!values.title) {
    errors.title = 'Required';
  }
  if (!values.url) {
    errors.url = 'Required';
  } else if (!isValidYouTubeUrl(values.url)) {
    errors.url = 'Invalid YouTube URL';
  }
  return errors;
};

const getVideoDetails = async (videoId) => {
  const url = `https://www.googleapis.com/youtube/v3/videos?part=snippet,contentDetails&id=${videoId}&key=${API_KEY}`;
  
  try {
    const response = await fetch(url);
    const data = await response.json();
    if (data.items.length > 0) {
      const videoData = data.items[0];
      const title = videoData.snippet.title;
      const description = videoData.snippet.description;
      const thumbnail = videoData.snippet.thumbnails.high.url;
      const durationISO = videoData.contentDetails.duration;
      
      const duration = parseDuration(durationISO);

      return { title, description, thumbnail, duration };
    } else {
      throw new Error('Video not found');
    }
  } catch (error) {
    console.error('Error fetching video details:', error);
    return null;
  }
};


const extractVideoId = (url) => {
  const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

const parseDuration = (isoDuration) => {
  const match = isoDuration.match(/PT(?:([\d]+)H)?(?:([\d]+)M)?(?:([\d]+)S)?/);
  const hours = parseInt(match[1], 10) || 0;
  const minutes = parseInt(match[2], 10) || 0;
  const seconds = parseInt(match[3], 10) || 0;

  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

const PlaylistModal = ({ open, onClose, onSubmit, playlistId, currentCategory }) => {
  
  const initialFormValues = {
    title: '',
    description: '',
    url: '',
    platform: 'youtube',
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [videoDetails, setVideoDetails] = useState({ title: '', description: '', thumbnail: '', duration: '' });
  const [s3Videos, setS3Videos] = useState([]);
  const [hoveredVideo, setHoveredVideo] = useState<number | null>(null);
  const [selectedVideos, setSelectedVideos] = useState<number[]>([]);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [url, setUrl] = useState(""); 
  

const [searchQuery, setSearchQuery] = useState('');
const [searchResults, setSearchResults] = useState([]);
const [nextPageToken, setNextPageToken] = useState(null);
const [showResults, setShowResults] = useState(false);
const [isLoading, setIsLoading] = useState(false);

const [modalOpen, setModalOpen] = useState(false);
const [modalVideoId, setModalVideoId] = useState(null);


  useEffect(() => {
    if (!open) {
      setFormValues(initialFormValues);
      setVideoDetails({ title: '', description: '', thumbnail: '', duration: '' });
    }
  }, [open]);

  const handleScrubVideoDetails = async (url, form) => {
    const videoId = extractVideoId(url);
    if (videoId) {
      const details = await getVideoDetails(videoId);
      if (details) {
        setVideoDetails({
          title: details.title,
          description: details.description,
          thumbnail: details.thumbnail,
          duration: details.duration,
        });
        form.change('title', details.title);
        form.change('description', details.description);
        
      } else {
        toast.error("Failed to fetch video details.");
      }
    } else {
      toast.error("Invalid YouTube URL.");
    }
  };
  const toggleSelection = (videoUrl: string) => {
    
    setSelectedVideos((prevSelected) => {
      const updatedSelection = prevSelected.includes(videoUrl)
        ? prevSelected.filter((url) => url !== videoUrl)
        : [...prevSelected, videoUrl];
  
      return updatedSelection;
    });
  };
  useEffect(() => {

  }, [selectedVideos]);

 const handleSubmitS3 = async (values) => {
  console.log("handleSubmitS3");

  const selectedVideoData = s3Videos
    .filter(video => selectedVideos.includes(video.url))
    .map(({ id, ...video }) => ({
      title: video.title || "",
      description: video.description || "",
      url: video.url,
      thumbnail: video.thumbnail || "",
      platform: video.platform || "s3",
      duration: video.duration || "00:00:00",
      type: "mp4",
    }));

  const updatedVideos = currentCategory.videos.map(({ id, ...video }) => ({
    title: video.title || "",
    description: video.description || "",
    url: video.url,
    thumbnail: video.thumbnail || "",
    platform: video.platform || "s3",
    duration: video.duration || "00:00:00",
    type: "mp4",
  }));

  const playlistPayload = [...updatedVideos, ...selectedVideoData];

  try {
    const response = await axios.put(`playlist/${playlistId}/save_playlist_items`, playlistPayload);
    if (response.status === 200 && response.data === true) {
      setSearchQuery("");
      setSearchResults([]);
      toast.success("Playlist item saved successfully");
      
    } else {
      toast.error("Failed to save playlist item.");
    }
  } catch (error) {
    console.error("Error saving playlist item:", error);
    toast.error("Failed to save playlist item.");
  }

  selectedVideoData.forEach(video => {
    onSubmit({
      ...values,
      duration: video.duration,
      thumbnail: video.thumbnail,
      title: video.title,
      url: video.url,
    });
  });

  selectedVideos.length = 0;
};


  const handleSubmit = async (values) => {
  const videoId = extractVideoId(values.url);
  console.log("handleSubmit");

  if (videoId) {
    try {
      const newVideo = {
        title: values.title || videoDetails.title || "",
        description: values.description || videoDetails.description || "",
        url: values.url,
        platform: values.platform || videoDetails.platform || "s3",
        duration: videoDetails.duration || "00:00:00",
        type: "mp4",
      };

     
      const updatedVideos = currentCategory.videos.map(({ id,  ...video }) => ({
        title: video.title || "",
        description: video.description || "",
        url: video.url,
        platform: video.platform || "s3",
        duration: video.duration || "00:00:00",
        type: "mp4",
      }));

        // Add the new video
        updatedVideos.push({
        title: values.title || videoDetails.title || "",
        description: values.description || videoDetails.description || "",
        url: values.url,
        platform: values.platform || videoDetails.platform || "s3",
        duration: videoDetails.duration || "00:00:00",
        type: "mp4",
      });

      const payload = updatedVideos;
      const response = await axios.put(`playlist/${playlistId}/save_playlist_items`, payload);

      if (response.status === 200) {
        const result = await response.data;
        if (result === true) {
          setSearchQuery("");
          setSearchResults([]);
          toast.success("Playlist item saved successfully");
        } else {
          toast.error("Failed to save playlist item.");
        }
      } else {
        toast.error("Failed to save playlist item.");
      }

      onSubmit({
        ...values,
        duration: newVideo.duration,
        thumbnail: videoDetails.thumbnail, 
      });
      
      
    } catch (error) {
      console.error("Error saving playlist item:", error);
      toast.error("Failed to save playlist item.");
    }
  } else {
    toast.error("Invalid YouTube URL");
  }
};


  const getS3Data = async () => {
    try {
      const response = await axios.get(`/playlist/global/get_global_playlist_items`);
      setS3Videos(response.data); 
    } catch (error) {
      console.error("Error fetching S3 playlist items:", error);
    }
  };
  const handleMouseEnter = (video: any, event: React.MouseEvent<HTMLElement>) => {
    setHoveredVideo(video.url);
    setAnchorEl(event.currentTarget); 
  };
  const handleMouseLeave = () => {
    setHoveredVideo(null);
    setAnchorEl(null); 
  };
  const handleModalClose = () => {
    setOpenModalPlaylist(false);  
    setUrl("");                   
    form.change("url", "");       
    form.change("title", "");     
    form.change("description", ""); 
  };

    useEffect(() => {
      if (url) {
        handleScrubVideoDetails(url, {});
      }
    }, [url])


const searchYouTubeVideos = async (query, pageToken = null) => {
  const baseUrl = `https://www.googleapis.com/youtube/v3/search?part=snippet&type=video&maxResults=20&q=${encodeURIComponent(
    query
  )}&key=${API_KEY}`;

  const url = pageToken ? `${baseUrl}&pageToken=${pageToken}` : baseUrl;

  try {
    const response = await fetch(url);
    const data = await response.json();
    return {
      items: data.items || [],
      nextPageToken: data.nextPageToken || null,
    };
  } catch (error) {
    console.error("YouTube Search Error:", error);
    return { items: [], nextPageToken: null };
  }
};

  const handleSearch = async () => {
    if (!searchQuery.trim()) return;
    setIsLoading(true);
    const { items, nextPageToken } = await searchYouTubeVideos(searchQuery.trim());
    setSearchResults(items);
    setNextPageToken(nextPageToken);
    setShowResults(true);
    setIsLoading(false);
  };

  const handleLoadMore = async () => {
    if (!nextPageToken) return;
    setIsLoading(true);
    const { items, nextPageToken: newToken } = await searchYouTubeVideos(searchQuery.trim(), nextPageToken);
    setSearchResults((prev) => [...prev, ...items]);
    setNextPageToken(newToken);
    setIsLoading(false);
  };

const handleScrubTikTokDetails = async (url: string, form: any) => {
  try {
    const res = await fetch(`https://www.tiktok.com/oembed?url=${encodeURIComponent(url)}`);
    const data = await res.json();

    console.log("TikTok Data:", data);
    setVideoDetails({
      title: data.title,
      thumbnail: data.thumbnail_url,
      description: `By ${data.author_name}`,
    });

    form.change('title', data.title);
    form.change('description', `By ${data.author_name}`);
    setFormValues((prev) => ({
      ...prev,
      title: data.title,
      description: `By ${data.author_name}`,
    }));
  } catch (error) {
    console.error("Failed to get TikTok details:", error);
  }
};

const handleScrubInstagramDetails = async (url: string, form: any) => {
  try {
    const res = await fetch(`https://jsonlink.io/api/extract?url=${encodeURIComponent(url)}`);
    const data = await res.json();

    console.log("Instagram Metadata:", data);

    setVideoDetails({
      title: data.title || 'Instagram Reel',
      thumbnail: data.images?.[0] || '', // fallback to first image
      description: data.description || '',
    });

    form.change('title', data.title || 'Instagram Reel');
    form.change('description', data.description || '');
    setFormValues((prev) => ({
      ...prev,
      title: data.title || 'Instagram Reel',
      description: data.description || '',
    }));
  } catch (error) {
    console.error("Failed to get Instagram details:", error);
    toast.error("Could not fetch Instagram Reel metadata. Ensure it's a public link.");
  }
};


  return (
    <Dialog
    open={open}
     onClose={(event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      onClose();
    }
  }}
    PaperProps={{
      sx: {
        width: "950px",
        borderRadius: "15px",
        padding: "20px",
        maxWidth: "100%",
        overflow: "hidden",
      },
    }}
  >
    <DialogTitle sx={{ fontSize: "1.25rem", fontWeight: "600" }}>
      Add New Playlist Item
    </DialogTitle>
    <DialogContent>
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        initialValues={formValues}
        render={({ handleSubmit, form, values }) => (
          <form
          onSubmit={async (e) => {
            await handleSubmit(e);
            form.reset(); 
            setUrl(""); 
            if (values.platform === "S3") {
              await handleSubmitS3(values);
            }
        
            form.reset();
          }}
        >
            {/* Platform Select */}
            <Box sx={{ mb: 2 }}>
              <Field name="platform">
                {({ input }) => (
                  <RffSelect
                    {...input}
                    label="Platform"
                    required
                    formControlProps={{ margin: "normal" }}
                    onChange={(e) => {
                      input.onChange(e);
                      if (e.target.value === "S3") {
                        getS3Data();
                      }
                    }}
                    sx={{
                      backgroundColor: "#f4f6f8",
                      borderRadius: "8px",
                      padding: "8px",
                    }}
                  >
                    <MenuItem value="youtube">YouTube</MenuItem>
                    <MenuItem value="S3">Stock Videos</MenuItem>
                    <MenuItem value="tk">Tik tok</MenuItem>
                    {/* <MenuItem value="ig">Instagram Reels</MenuItem> */}
                  </RffSelect>
                )}
              </Field>
            </Box>
  
            {/* YouTube Area */}
            {values.platform === "youtube" && (
              <Box sx={{ mb: 2 }}>
                {/* 🔍 YouTube Search Field */}
                <Box sx={{ mb: 2 }}>
                <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              <TextField
                label="Search YouTube Videos"
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
                sx={{ backgroundColor: "#f4f6f8", borderRadius: "8px" }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSearch}
                disabled={isLoading}
              >
                {isLoading ? "Searching..." : "Search"}
              </Button>
            </Box>

      {showResults && searchResults.length > 0 && (
  <>
    
    <Box
      sx={{
        mt: 1,
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: 3,
        maxHeight: 400,
        overflowY: "auto",
        zIndex: 10,
        position: "relative",
        display: "grid",
        gap: 2,
        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
        p: 1,
      }}
    >
      {searchResults.map((video) => {
        const videoId = video.id.videoId;
        const title = video.snippet.title;
        const thumbnail = video.snippet.thumbnails.medium.url;

        return (
        <Card
          key={videoId}
          sx={{
            position: 'relative', // for absolute icon positioning
            cursor: 'pointer',
            borderRadius: 2,
            boxShadow: 2,
            transition: 'transform 0.2s',
            '&:hover': {
              transform: 'scale(1.02)',
              boxShadow: 4,
            },
          }}
          onClick={async () => {
            const fullUrl = `https://www.youtube.com/watch?v=${videoId}`;
            setUrl(fullUrl);
            const details = await getVideoDetails(videoId);
            if (details) {
              setVideoDetails(details);
              form.change('url', fullUrl);
              form.change('title', details.title);
              form.change('description', details.description);
              setFormValues((prev) => ({
                ...prev,
                url: fullUrl,
                title: details.title,
                description: details.description,
              }));
              setSearchResults([]);
              setShowResults(false);
            }
          }}
        >
       
         <IconButton
            aria-label="preview video"
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              bgcolor: 'rgb(255, 255, 255)', 
              color: 'green',                    
              '&:hover': {
                bgcolor: 'rgba(240, 26, 26, 0.35)', 
                color: 'darkgreen',                 
                transform: 'scale(1.1)',            
              },
              zIndex: 10,
              transition: 'all 0.3s ease',
            }}
            onClick={(e) => {
              e.stopPropagation();
              setModalVideoId(videoId);
              setModalOpen(true);
            }}
          >
            <VisibilityIcon fontSize="medium" />
          </IconButton>

          <CardMedia component="img" height="140" image={thumbnail} alt={title} />
          <CardContent sx={{ p: 1 }}>
            <Typography variant="body2" fontWeight={600}>
              {title.length > 70 ? title.slice(0, 67) + '...' : title}
            </Typography>
          </CardContent>
        </Card>
        );
      })}
    </Box>

   
    {nextPageToken && (
      <Box sx={{ textAlign: "center", mt: 2 }}>
        <Button variant="outlined" onClick={handleLoadMore} disabled={isLoading}>
          {isLoading ? "Loading..." : "Load More"}
        </Button>
      </Box>
    )}
  </>
)}
    </Box>

    <Modal
  open={modalOpen}
  onClose={() => setModalOpen(false)}
  aria-labelledby="video-modal"
  aria-describedby="video-player-modal"
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <Box
    sx={{
      position: 'relative',
      width: { xs: '90%', sm: 640 },
      height: { xs: '50vh', sm: 360 },
      bgcolor: 'background.paper',
      boxShadow: 24,
      borderRadius: 2,
      outline: 'none',
    }}
  >
    {modalVideoId && (
      <iframe
        width="100%"
        height="100%"
        src={`https://www.youtube.com/embed/${modalVideoId}?autoplay=1&mute=0&controls=1`}
        title="YouTube video player"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      />
    )}
  </Box>
</Modal>


    {/*YouTube URL Field */}
    <Field name="url">
      {({ input, meta }) => (
        <TextField
          {...input}
          label="YouTube Video URL"
          fullWidth
          required
          value={url}
          onChange={(e) => {
            setUrl(e.target.value);
            input.onChange(e);
          }}
          onPaste={(e) => {
            const pastedText = e.clipboardData.getData("text");
            setTimeout(() => {
              setUrl(pastedText);
              input.onChange(pastedText);
              handleScrubVideoDetails(pastedText, form);
              setFormValues((prev) => ({ ...prev, url: pastedText }));
            }, 0);
          }}
          onBlur={() => {
            if (input.value?.trim()) {
              handleScrubVideoDetails(input.value, form);
              setFormValues((prev) => ({ ...prev, url: input.value }));
            }
          }}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          sx={{
            mb: 2,
            backgroundColor: "#f4f6f8",
            borderRadius: "8px",
          }}
        />
      )}
    </Field>

   
    {videoDetails.thumbnail && (
      <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
        <img
          src={videoDetails.thumbnail}
          alt="Video Thumbnail"
          style={{ width: "100%", borderRadius: "8px" }}
        />
      </Box>
    )}

   
    {url && videoDetails.title && (
      <>
        <Field name="title">
          {({ input, meta }) => (
            <TextField
              {...input}
              label="Video Title"
              fullWidth
              value={values.title || videoDetails.title}
              onChange={(e) => {
                input.onChange(e);
                setFormValues((prev) => ({
                  ...prev,
                  title: e.target.value,
                }));
              }}
              error={meta.touched && Boolean(meta.error)}
              helperText={meta.touched && meta.error}
              sx={{
                mb: 2,
                backgroundColor: "#f4f6f8",
                borderRadius: "8px",
              }}
            />
          )}
        </Field>

        <Field name="description">
          {({ input, meta }) => (
            <TextField
              {...input}
              label="Description"
              fullWidth
              multiline
              rows={3}
              value={values.description || videoDetails.description}
              onChange={(e) => {
                input.onChange(e);
                setFormValues((prev) => ({
                  ...prev,
                  description: e.target.value,
                }));
              }}
              error={meta.touched && Boolean(meta.error)}
              helperText={meta.touched && meta.error}
              sx={{
                mb: 2,
                backgroundColor: "#f4f6f8",
                borderRadius: "8px",
              }}
            />
          )}
        </Field>
      </>
    )}
  </Box>
          )}

      {values.platform === "tk" && (
          <Field name="tiktokCopyUrl">
            {({ input, form }) => (
              <Box sx={{ mb: 2 }}>
                <TextField
                  {...input}
                  label="Paste TikTok Video URL"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={url}
                  onChange={async (e) => {
                    const value = e.target.value;
                    input.onChange(value);
                    setUrl(value);
                    if (value.includes("tiktok.com")) {
                      await handleScrubTikTokDetails(value, form);
                    }
                  }}
                />

                {videoDetails?.title || videoDetails?.thumbnail ? (
                    <Box sx={{ mt: 1, p: 1, border: '1px solid #ddd', borderRadius: 1 }}>
                     
                      <Field name="title" initialValue={videoDetails.title || ''}>
                        {({ input }) => (
                          <TextField
                            {...input}
                            label="Title"
                            variant="outlined"
                            value={input.value}
                            size="small"
                            fullWidth
                            sx={{ mb: 1 }}
                          />
                        )}
                      </Field>
                      
                      {videoDetails.thumbnail && (
                        <img
                          src={videoDetails.thumbnail}
                          alt="Instagram thumbnail"
                          style={{
                            width: '100%',
                            maxHeight: 650,
                            objectFit: 'cover',
                            marginTop: 8,
                          }}
                        />
                      )}
                    </Box>
                  ) : null}


                
                  <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                  <Button
                    onClick={() => {
                      form.reset();
                      setUrl("");
                      form.change("url", "");
                      form.change("title", "");
                      form.change("description", "");
                      setSearchResults([]);
                      setSearchQuery("");
                      onClose();
                    }}
                    color="primary"
                  >
                    Cancel
                  </Button>

                 <Button
  variant="contained"
  color="primary"
  size="small"
  onClick={async () => {
    try {
      const newVideo = {
        title: values.title || videoDetails?.title || '',
        description: values.description || videoDetails?.description || '',
        url: values.tiktokCopyUrl || url || '',
        platform: 'tiktok',
        duration: videoDetails?.duration || '00:00:00',
        type: 'mp4',
        thumbnail: videoDetails?.thumbnail || '',
      };

      // Map existing playlist videos (remove ID if present)
      const existingVideos = currentCategory.videos.map(({ id, ...video }) => ({
        title: video.title || '',
        description: video.description || '',
        url: video.url,
        platform: video.platform || 's3',
        duration: video.duration || '00:00:00',
        type: 'mp4',
        thumbnail: video.thumbnail || '',
      }));

      // Add the new TikTok video
      const payload = [...existingVideos, newVideo];

      const response = await axios.put(
        `/playlist/${playlistId}/save_playlist_items`,
        payload
      );

      if (response.status === 200) {
        toast.success('TikTok Reel added to playlist successfully');
        setUrl('');
        setVideoDetails({});
        setSearchQuery('');
        setSearchResults([]);
        onClose(); 
        
      } else {
        toast.error('Failed to add to playlist.');
      }

      onSubmit({
        ...values,
        duration: newVideo.duration,
        thumbnail: videoDetails.thumbnail, 
        title: newVideo.title,
        url: newVideo.url,
        platform: newVideo.platform,
      });
      
    } catch (error) {
      console.error('Error adding to playlist:', error);
      toast.error('Failed to add TikTok Reel to playlist');
    }
  }}
>
  Add
</Button>

                </Box>

              </Box>
            )}
          </Field>
        )}  

    {values.platform === "ig" && (
  <Field name="instagramReelUrl">
    {({ input, form }) => (
      <Box sx={{ mb: 2 }}>
        <TextField
          {...input}
          label="Paste Instagram Reels video URL"
          variant="outlined"
          fullWidth
          size="small"
          value={url}
          onChange={async (e) => {
            const value = e.target.value;
            input.onChange(value);
            setUrl(value);

            if (value.includes("instagram.com/reel")) {
              await handleScrubInstagramDetails(value, form); 
            }
          }}
        />

        {videoDetails && (
          <Box sx={{ mt: 1, p: 1, border: '1px solid #ddd', borderRadius: 1 }}>
            <Typography variant="subtitle2">{videoDetails.title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {videoDetails.description}
            </Typography>
            <img
              src={videoDetails.thumbnail}
              alt="Instagram thumbnail"
              style={{
                width: '100%',
                maxHeight: 200,
                objectFit: 'cover',
                marginTop: 8,
              }}
            />
          </Box>
        )}

        <Button
          onClick={() => {
            form.reset();
            setUrl("");
            form.change("url", "");
            form.change("title", "");
            form.change("description", "");
            setSearchResults([]);
            setSearchQuery("");
            onClose();
          }}
          color="primary"
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ mt: 0 }}
          onClick={async () => {
            try {
              const payload = {
                title: videoDetails?.title || '',
                description: videoDetails?.description || '',
                url: url || form.getState().values.instagramReelUrl || '',
                platform: 'instagram',
                duration: videoDetails?.duration || '00:00:00',
                type: 'mp4',
              };

              const response = await axios.put(
                `/playlist/${playlistId}/save_playlist_items`,
                payload
              );

              if (response.status === 200) {
                toast.success('Instagram Reel added to playlist successfully');
              } else {
                alert('Failed to add to playlist.');
              }
            } catch (error) {
              console.error('Error adding to playlist:', error);
              toast.error('Failed to add Instagram Reel to playlist');
            }
          }}
        >
          Add to Playlist
        </Button>
      </Box>
    )}
  </Field>
      )}

  
            {/* S3 Video Selection */}
            {values.platform === "S3" && (
              <Box sx={{ mb: 2, p: 4, border: "1px solid #ccc", borderRadius: "8px" }}>
                <Typography variant="h6" sx={{ fontWeight: "600", marginBottom: "10px" }}>
                  Select videos to add to your playlist
                </Typography>
  
                {s3Videos.length > 0 ? (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: 2,
                      mt: 2,
                    }}
                  >
                    {s3Videos.map((video) => (
                      <Card
                        key={video.url}
                        sx={{
                          cursor: "pointer",
                          position: "relative",
                          borderRadius: "8px",
                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                          transition: "transform 0.3s ease",
                          "&:hover": {
                            transform: "scale(1.05)",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                          },
                          border: selectedVideos.includes(video.url)
                            ? "3px solid #4caf50"
                            : "none",
                        }}
                        onMouseEnter={(e) => handleMouseEnter(video, e)}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => toggleSelection(video.url)}
                      >
                        {hoveredVideo === video.url ? (
                          <video
                            src={video.url}
                            width="100%"
                            height="120"
                            autoPlay
                            muted
                            loop
                            style={{
                              borderRadius: "8px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <CardMedia
                            component="img"
                            height="120"
                            image={video.thumbnail}
                            alt={video.title}
                          />
                        )}
  
                   
  
                        <CardContent>
                          <Typography variant="body2" noWrap>
                            {video.title}
                          </Typography>
                        </CardContent>
  
                        {/* Display selection icon */}
                        {selectedVideos.includes(video.url) && (
                          <Box
                            sx={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              backgroundColor: "rgba(0, 0, 0, 0.6)",
                              borderRadius: "50%",
                              padding: "5px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <CheckCircleIcon sx={{ color: "white" }} />
                          </Box>
                        )}
                      </Card>
                    ))}
                  </Box>
                ) : (
                  <Typography sx={{ mt: 2, color: "gray" }}>No videos found.</Typography>
                )}
              </Box>
            )}
  
         {values.platform !== "tk" && (
          <DialogActions>
            <Button
              onClick={() => {
                form.reset();
                setUrl("");
                form.change("url", "");
                form.change("title", "");
                form.change("description", "");
                setSearchResults([]);
                setSearchQuery("");
                onClose();
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button type="submit" color="primary" variant="contained">
              Add
            </Button>
          </DialogActions>
        )}

          </form>
        )}
      />
    </DialogContent>
  </Dialog>
  
  );
};

export default PlaylistModal;
